import React from "react";
var __jsx = React.createElement;
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import ProgressBar from "@componentsShared/ProgressBar";
import useIsWebView from "@hooks/useIsWebview";
import { If } from "@componentsShared/Conditional/If";
var CarInitialScreen = function CarInitialScreen() {
  var isWebView = useIsWebView();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-initial-screen",
    className: "min-h-[100dvh] overscroll-none fixed inset-0"
  }, /*#__PURE__*/React.createElement(If, {
    condition: !isWebView
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-alice overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:bg-blue-alice md:min-h-[285px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-3 pb-4 flex items-center justify-between md:max-w-[2000px] md:w-[90%] md:mx-auto md:pt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6"
  })), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-initial-loading-header",
    className: "flex flex-col w-full px-4 gap-4 pb-4 md:max-w-[916px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-2 flex items-center justify-center bg-blue-lavender rounded-lg shadow-[0px_0px_0.800000011920929px_0px_rgba(13,13,181,1.00)]"
  }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-initial-shimmer",
    className: "relative overflow-hidden bg-[#E0E0E0] h-4 w-20 rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 -translate-x-full",
    style: {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
      animation: 'shimmer 1.5s infinite'
    }
  }), /*#__PURE__*/React.createElement("style", null, "\n                                    @keyframes shimmer {\n                                        100% { transform: translateX(100%); }\n                                    }\n                                "))), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: 0,
    color: "primary",
    showLabel: false,
    height: "h-1",
    background: "bg-[#bbbbc9]"
  }))))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-initial-loading-spinner",
    className: "h-full flex w-full justify-center items-center"
  }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null))));
};
export default CarInitialScreen;